import React from 'react'
import { PATHS } from 'utils/paths'
import { Navigate } from "react-router-dom";

const HomePage = () => <Navigate to={PATHS.login}/>

export default HomePage
